<script lang="ts">
    import { setContext } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'
    import type { Writable } from 'svelte/store'

    import { Router, type RouteConfig } from '@mateothegreat/svelte5-router'

    import { gettext as _ } from 'hydria/services/gettext'
    import { readAsIdna, spath } from 'hydria/svelte_helpers'

    import { DomainHandler } from './domain'

    import Contacts from './Contacts.svelte'
    import Domain from './Domain.svelte'
    import Nameservers from './Nameservers.svelte'
    import RevisionDiff from './RevisionDiff.svelte'

    interface Props {
        route: any
    }

    let { route = {} }: Props = $props()

    const domain = new DomainHandler()
    const domainIdna: Writable<string | undefined> = writable(readAsIdna(route.result.path.params?.idna))

    $effect(() => {
        $domainIdna = route.result.path.params?.idna != null ? readAsIdna(route.result.path.params?.idna) : undefined
        if ($domainIdna) domain.reset($domainIdna)
    })

    setContext(
        'domainIdna',
        sderived(domainIdna, ($domainIdna) => $domainIdna),
    )
    setContext('Domain', domain)

    const routes: RouteConfig[] = [
        { path: '/', component: Domain },
        { path: '/nameservers', component: Nameservers },
        { path: '/contacts', component: Contacts },
        { path: '/revision-diff', component: RevisionDiff },
    ]
</script>

<Router {routes} basePath={spath(`/domain/${$domainIdna}`)} />
